<template>
  <div>
    <div class="header height-100vh bg-gradient-white py-5 py-lg-5 pt-lg-5">
      <b-container>
        <div class="header-body text-center mb-2">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="6" class="px-2">
              <h1 class="text-dark">{{ $t('error.title') }}</h1>
              <p class="text-lead text-dark">{{ $t('error.pagenotfound') }}</p>

              <router-link to="/" class="font-weight-bold text-dark mt-5">{{ $t('generic.backtohome') }}</router-link>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>

export default {
  name: 'not-found'
};
</script>
